import { createRouter, createWebHistory } from 'vue-router';
import { nextTick } from 'vue';
import MainRoute from '@/modules/app/Router/main.js';
import token from '@/modules/global/services/token';

const indexRoutes = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/',
        name: 'MainPage',
        component: () => import('@/modules/app/MainPage.vue'),
        children: [...MainRoute],
    },
    {
        path: '/login',
        name: 'LoginPage',
        component: () => import('@/modules/auth/LoginPage.vue'),
    },
    {
        path: '/login/auth/forgot-password',
        name: 'ForgotPasswordPage',
        component: () => import('@/modules/auth/ForgotPasswordPage.vue'),
    },
    {
        path: '/login/auth/renew-password',
        name: 'RenewPassword',
        component: () => import('@/modules/auth/RenewPasswordPage.vue'),
    },
    // Custom Login
    {
        path: '/man1-bantul',
        name: 'LoginPageMan1Bantul',
        component: () =>
            import('@/modules/auth/CustomLogin/LoginPageMan1Bantul.vue'),
    },
    {
        path: '/man3bantul',
        name: 'LoginPageMan3Bantul',
        component: () =>
            import('@/modules/auth/CustomLogin/LoginPageMan3Bantul.vue'),
    },
    {
        path: '/man4bantul',
        name: 'LoginPageMan4Bantul',
        component: () =>
            import('@/modules/auth/CustomLogin/LoginPageMan4Bantul.vue'),
    },
    {
        path: '/man3-sleman',
        name: 'LoginPageMan3Sleman',
        component: () =>
            import('@/modules/auth/CustomLogin/LoginPageMan3Sleman.vue'),
    },
    {
        path: '/man1-gunung-kidul',
        name: 'LoginPageMan1GunungKidul',
        component: () =>
            import('@/modules/auth/CustomLogin/LoginPageMan1GunungKidul.vue'),
    },
    {
        path: '/sma-kartika-xxi-makassar',
        name: 'LoginPageSmaKartika',
        component: () =>
            import('@/modules/auth/CustomLogin/LoginPageSmaKartika.vue'),
    },
];

const routes = [...indexRoutes];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0 };
    },
});

// layout Vuetify (v-app > v-main) scroll di elemen .v-main, bukan window,
// jadi scrollBehavior bawaan vue-router tidak cukup untuk halaman itu
router.afterEach(() => {
    nextTick(() => {
        const main = document.querySelector('.v-main');

        if (main) {
            main.scrollTop = 0;
        }
    });
});

router.beforeEach((to, from, next) => {
    const requiredScopes = to.meta?.scopes;
    // daftar email untuk menu yang masih uji coba, lihat juga AppSidebar
    const allowedEmails = to.meta?.emails;

    // halaman publik (login, dll)
    if (!requiredScopes && !allowedEmails) {
        return next();
    }

    // token invalid / expired
    if (!token.isTokenValid()) {
        token.removeToken();
        return next({ name: 'LoginPage' });
    }

    const decoded = token.decodeToken();
    const userScopes = decoded?.app_scopes || [];
    const userEmail = (decoded?.user_email || '').trim().toLowerCase();

    const hasScope = (requiredScopes || []).every((scope) =>
        userScopes.includes(scope)
    );

    const hasEmail = !allowedEmails || allowedEmails.includes(userEmail);

    if (hasScope && hasEmail) {
        next();
    } else {
        next({ path: '/halaman-tidak-tersedia' }); // atau page 403
    }
});

export default router;
